module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('aside', {
    staticClass: "docs-navbar"
  }, [_vm._m(0), " ", _h('ul', {
    staticClass: "nav"
  }, [_h('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "to": "/postcss-salad/index"
    }
  }, [_h('a', ["Overview"])]), " ", _h('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "to": "/postcss-salad/reset"
    }
  }, [_h('a', [" Reset and Normalize"])]), " ", _h('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "to": "/postcss-salad/lasted-syntax"
    }
  }, [_h('a', ["Lasted CSS Syntax"])]), " ", _h('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "to": "/postcss-salad/short-property"
    }
  }, [_h('a', ["Short Property"])]), " ", _h('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "to": "/postcss-salad/grid"
    }
  }, [_h('a', ["Grid"])]), " ", _h('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "to": "/postcss-salad/basic-shape"
    }
  }, [_h('a', ["Basic Shape"])]), " ", _h('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "to": "/postcss-salad/utils"
    }
  }, [_h('a', [" Utils"])]), " ", _h('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "to": "/postcss-salad/inline-svg"
    }
  }, [_h('a', ["Inline Svg"])]), " ", _h('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "to": "/postcss-salad/Rem-to-Pixel"
    }
  }, [_h('a', ["Rem to Pixel"])]), " ", _h('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "to": "/postcss-salad/sass-syntax"
    }
  }, [_h('a', ["Sass Syntax"])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "aside-top"
  }, ["Salad", _h('img', {
    staticClass: "salad-logo",
    attrs: {
      "src": require("assets/logo.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e29491fe!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/src/components/Sidenav.vue
// module id = 21
// module chunks = 1